var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmoothRoundedCorner = function SvgSmoothRoundedCorner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19v2H3v-2zM9 19v2H7v-2zM13 19v2h-2v-2zM17 19v2h-2v-2zM21 21h-2v-2h2zM5 15v2H3v-2zM11 3c5.523 0 10 4.477 10 10v4h-2v-4a8 8 0 0 0-8-8H7V3zM5 11v2H3v-2zM5 7v2H3V7zM5 3v2H3V3z"
  })));
};
export default SvgSmoothRoundedCorner;